/**
 * Tests if a mobile device is used.
 * @returns True if the browser is a mobile browser. False otherwise.
 */
export default function () {
  return 'ontouchstart' in document.documentElement;
}
